import { axiosInstance } from '..';
export const fetchTicketVariants = async (id, token) => {
	const header = {
		headers: { Authorization: `Bearer ${token}` },
	};
	const url = `/BuyTicket/GetPriceIdPerSeatZone/${id}`;
	const res = await axiosInstance.get(url, header);
	return res.data;
};
